import { createFileRoute } from "@tanstack/react-router";
import { QuoteCreationSettingsPage } from "../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/quote-creation")({
  component: QuoteCreationSettingsPage,
});
